// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o7pdX","toggleWrap":"styles_toggleWrap__p3-Dv","content":"styles_content__2_RQo","selectAreaCode":"styles_selectAreaCode__1wAfn"};